module.exports = __webpack_public_path__ + "img/invoice.7d974b28.svg";